import {Routes} from '@angular/router';
import {AuthGuard} from '@core/guard/auth.guard';
import {ROUTES as ADMIN_ROUTES} from '@modules/administration/administration-routing.module';

export const COMMON_LAYOUT_ROUTES: Routes = [
    {
        path: 'dashboard',
        loadChildren: () => import('../../modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard]
    },
    {
      path: ADMIN_ROUTES.PREFIX,
      loadChildren: () => import('../../modules/administration/administration.module').then(m => m.AdministrationModule),
      canActivate: [AuthGuard]
    }
];
